import { useState } from 'react';

interface IModalHook {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useModal = (): IModalHook => {
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return { open, onOpen, onClose };
};

export default useModal;
